import React, { useEffect, useState, useLayoutEffect, createRef } from "react";
// core components
import { Route, Redirect } from 'react-router-dom';
import { authenticationService } from '_services';
import { handleResponse, authHeader } from '_helpers';

//import axios from 'axios';
// reactstrap components
import {
    Label,
    FormGroup,
    Button,
    Input,
    Modal,
    ModalBody,
    Container,
    Row,
    Col,
} from "reactstrap";
import Datetime from 'react-datetime';
import TSText from "components/Forms/TSText.js";
import TSSelect from "components/Forms/TSSelect.js";

import TSNavbar from "components/Navbars/TSNavbar";
import TrangskinPageHeader from "components/Headers/TrangskinPageHeader2.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";
import 'assets/css/react-datetime.css'

const ChildRegister = (props) => {
    const [userID, setUserID] = useState('');
    const [title, setTitle] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [hn, setHN] = useState('');
    const [idCard, setIdCard] = useState('');
    const [gender, setGender] = useState('');
    const [bDay, setbDay] = useState("");
    const [bMonth, setbMonth] = useState("");
    const [bYear, setbYear] = useState("");
    const [email, setEmail] = useState('');
    const [address, setAddress] = useState('');
    const [moo, setMoo] = useState('');
    const [soi, setSoi] = useState('');
    const [road, setRoad] = useState('');
    const [district, setDistrict] = useState('');
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [amphur, setAmphur] = useState('');
    const [province, setProvince] = useState('');
    const [zipcode, setZipcode] = useState('');
    const [postcode, setPostcode] = useState('');
    const [isSameAddress, setIsSameAddress] = useState('');
    const [r_Address, setR_Address] = useState('');
    const [r_Moo, setR_Moo] = useState('');
    const [r_District, setR_District] = useState('');
    const [r_Amphur, setR_Amphur] = useState('');
    const [r_Province, setR_Province] = useState('');
    const [r_Zipcode, setR_Zipcode] = useState('');
    const [r_Postcode, setR_Postcode] = useState('');
    const [phone, setPhone] = useState('');
    const [nation, setNation] = useState('');
    const [race, setRace] = useState('');
    const [religion, setReligion] = useState('');
    const [occupation, setOccupation] = useState('');
    const [education, setEducation] = useState('');
    const [bloodGroup, setBloodGroup] = useState('');
    const [mar_Status, setMar_Status] = useState('');
    const [mar_Title, setMar_Title] = useState('');
    const [mar_FirstName, setMar_FirstName] = useState('');
    const [mar_LastName, setMar_LastName] = useState('');
    const [father_Title, setFather_Title] = useState('');
    const [father_FirstName, setFather_FirstName] = useState('');
    const [father_LastName, setFather_LastName] = useState('');
    const [mother_Title, setMother_Title] = useState('');
    const [mother_FirstName, setMother_FirstName] = useState('');
    const [mother_LastName, setMother_LastName] = useState('');
    const [drugNote, setDrugNote] = useState('');
    const [ptnNote, setPtnNote] = useState('');

    const [errMsg, setErrMsg] = React.useState(false);
    const [modalError, setModalError] = React.useState(false);
    const [modalConfirm, setModalConfirm] = React.useState(false);
    const [modalNote, setModalNote] = useState(false);
    const [icon, setIcon] = useState("far fa-question-circle");

    const [titleOption, setTitleOption] = useState([]);
    const [raceOption, setRaceOption] = useState([]);
    const [nationOption, setNationOption] = useState([]);




    const [i_title, invalidTitle] = useState(false);
    const [i_firstName, invalidFirstname] = useState(false);
    const [i_lastName, invalidLastName] = useState(false);
    const [i_idCard, invalidIdCard] = useState(false);
    const [i_gender, invalidGender] = useState(false);
    const [i_birthDate, invalidBirthDate] = useState(false);
    const [i_address, invalidAddress] = useState(false);
    const [i_district, invalidDistrict] = useState(false);
    const [i_amphur, invalidAmphur] = useState(false);
    const [i_province, invalidProvince] = useState(false);
    const [i_postcode, invalidPostcode] = useState(false);
    const [i_phone, invalidPhone] = useState(false);
    const [i_nation, invalidNation] = useState(false);
    const [i_race, invalidRace] = useState(false);
    const [i_religion, invalidReligion] = useState(false);
    const [i_occupation, invalidOccupation] = useState(false);
    const [i_education, invalidEducation] = useState(false);
    const [i_bloodGroup, invalidBloodGroup] = useState(false);
    const [i_mar_Status, invalidMar_Status] = useState(false);
    const [i_mar_Title, invalidMar_Title] = useState(false);
    const [i_mar_FirstName, invalidMar_FirstName] = useState(false);
    const [i_mar_LastName, invalidMar_LastName] = useState(false);
    const [i_father_Title, invalidFather_Title] = useState(false);
    const [i_father_FirstName, invalidFather_FirstName] = useState(false);
    const [i_father_LastName, invalidFather_LastName] = useState(false);
    const [i_mother_Title, invalidMother_Title] = useState(false);
    const [i_mother_FirstName, invalidMother_FirstName] = useState(false);
    const [i_mother_LastName, invalidMother_LastName] = useState(false);

    React.useEffect(() => {

        fetch("/api/v1/title"/*, { method: 'GET', headers: { 'Content-Type': 'application/json-patch+json' } }*/)
            .then(response => response.json())
            .then((result) => { setTitleOption(result.data) }, (error) => { console.log(error) })

        fetch("/api/v1/race"/*, { method: 'GET', headers: { 'Content-Type': 'application/json-patch+json' } }*/)
            .then(response => response.json())
            .then((result) => { setRaceOption(result.data) }, (error) => { console.log(error) })

        fetch("/api/v1/nation"/*, { method: 'GET', headers: { 'Content-Type': 'application/json-patch+json' } }*/)
            .then(response => response.json())
            .then((result) => { setNationOption(result.data) }, (error) => { console.log(error) })

       
        
        document.body.classList.add("profile-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        return function cleanup() {
            document.body.classList.remove("profile-page");
            document.body.classList.remove("sidebar-collapse");
        };

        
    },[]);
   
    
    useLayoutEffect(() => {

    }, []);
  

    const handleSubmit = (evt) => {
        evt.preventDefault();

        var birthDate = moment([bYear, bMonth - 1, bDay]);

        var errMsg = '';

        if (!title)
            errMsg = 'คำนำหน้า';
        else if (!firstName)
            errMsg = 'ชื่อ';
        else if (!lastName)
            errMsg = 'นามสกุล'; 
        else if (!gender)
            errMsg = 'เพศ';
        else if (!birthDate.isValid())
            errMsg = 'กรุณาระบุวันเดือนปีเกิดให้ถูกต้อง';
        else if (!phone)
            errMsg = 'หมายเลขโทรศัพท์';
        else if (!address) 
            errMsg = 'บ้านเลขที่';
        else if (!district)
            errMsg = 'ตำบล';
        else if (!amphur)
            errMsg = 'อำเภอ';
        else if (!province)
            errMsg = 'จังหวัด';
        else if (!postcode)
            errMsg = 'รหัสไปรษณีย์';
        else if (!mar_Status)
            errMsg = 'สถานภาพ';
        else if (mar_Status == 2 && !mar_Title)
            errMsg = 'คำนำหน้าคู่สมรส';
        else if (mar_Status == 2 && !mar_FirstName)
            errMsg = 'ชื่อคู่สมรส';
        else if (mar_Status == 2 && !mar_LastName)
            errMsg = 'นามสกุลคู่สมรส';
        else if (!nation)
            errMsg = 'เชื้อชาติ';
        else if (!race)
            errMsg = 'สัญชาติ';
        else if (!religion)
            errMsg = 'ศาสนา';
        else if (!occupation)
            errMsg = 'อาชีพ';
        else if (!education)
            errMsg = 'การศึกษา';
        else if (!bloodGroup)
            errMsg = 'กลุ่มเลือด';
        else if (!father_Title)
            errMsg = 'คำนำหน้าบิดา';
        else if (!father_FirstName)
            errMsg = 'ชื่อบิดา';
        else if (!father_LastName)
            errMsg = 'นามสกุลบิดา';
        else if (!mother_Title)
            errMsg = 'คำนำหน้ามารดา';
        else if (!mother_FirstName)
            errMsg = 'ชื่อมารดา';
        else if (!mother_LastName)
            errMsg = 'นามสกุลมารดา';

        invalidBirthDate(!birthDate.isValid());

        invalidTitle(!title);
        invalidFirstname(!firstName);
        invalidLastName(!lastName);
        invalidGender(!gender);
        invalidAddress(!address);
        invalidGender(!district);
        invalidAmphur(!amphur);
        invalidProvince(!province);
        invalidPostcode(!postcode);

        invalidMar_Status(!mar_Status);

        if (mar_Status == 2) {
            invalidMar_Title(!mar_Title);
            invalidMar_FirstName(!mar_FirstName);
            invalidMar_LastName(!mar_LastName);
        }
        else {
            invalidMar_Title(false);
            invalidMar_FirstName(false);
            invalidMar_LastName(false);
        }

        invalidPhone(!phone);
        invalidNation(!nation);
        invalidRace(!race);
        invalidReligion(!religion);
        invalidOccupation(!occupation);
        invalidEducation(!education);
        invalidBloodGroup(!bloodGroup);
        invalidFather_Title(!father_Title);
        invalidFather_FirstName(!father_FirstName);
        invalidFather_LastName(!father_LastName);
        invalidMother_Title(!mother_Title);
        invalidMother_FirstName(!mother_FirstName);
        invalidMother_LastName(!mother_LastName);

        
        if (errMsg != '') {
            setErrMsg('กรุณาระบุ' + errMsg);
            setModalError(true);
        }
        else {
            setModalConfirm(true);
        }
    }



 
    const handleConfirm = (evt) => {
        evt.preventDefault();

        setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

        var birthdate = moment([bYear, bMonth - 1, bDay]);

        var body = {
            firstName: firstName,
            lastName: lastName,
            idCard: idCard,
            birthDate: birthdate,
            address: address,
            moo: moo,
            soi: soi,
            road: road,

            thDistrict: district,
            thAmphur: amphur,
            thProvince: province,
            zipcode: zipcode,
            postcode: postcode,

            isSameAddress: isSameAddress,
            r_Address: r_Address,
            r_Moo: r_Moo,
            r_District: r_District,
            r_Amphur: r_Amphur,
            r_Province: r_Province,
            r_Zipcode: r_Zipcode,
            r_Postcode: r_Postcode,
            phone: phone,
            //nation: nation,
            //race: race,
            //religion: religion,
            //occupation: occupation,
            //education: education,
            bloodGroup: bloodGroup,
            mar_Status: mar_Status,
            //mar_Title: mar_Title,
            mar_FirstName: mar_FirstName,
            mar_LastName: mar_LastName,
            //father_Title: father_Title,
            father_FirstName: father_FirstName,
            father_LastName: father_LastName,
            //mother_Title: mother_Title,
            mother_FirstName: mother_FirstName,
            mother_LastName: mother_LastName,
            drugNote: drugNote,
            ptnNote: ptnNote,

            titleKey: title,
            genderKey: gender,
            nationalityKey: nation,
            raceKey: race,
            religionKey: religion,
            occupationKey: occupation,
            educationLevelKey: education,
            //aboBloodTypeKey: 0,
            //rhBloodGroupKey: 0,
            maritalStatusKey: mar_Status,
            fatherTitleKey: father_Title,
            motherTitleKey: mother_Title,
            marTitleKey: mar_Title,
        }

        fetch('/api/v1/childuser', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json-patch+json', ...authHeader() },
            body: JSON.stringify(body)
        })
            .then(handleResponse)
            .then(
                (result) => {
                    setModalConfirm(false);
                    setModalNote(true)
                },
                (error) => {
                    setModalConfirm(false);
                    setIcon("far fa-question-circle");
                    setErrMsg(error);
                    setModalError(true);
                }
            );         
    }

    var moment = require('moment');
    require('moment/locale/th');

    const currentUser = authenticationService.currentUserValue;
    if (!currentUser) {
        // not logged in so redirect to login page with the return url
        return <Redirect to={{ pathname: '/login', /*state: { from: props.location }*/ }} />
    }


  return (
    <>
      <TSNavbar />
      <div className="wrapper">
        <TrangskinPageHeader />
            <div className="section section-contact-us " style={{padding:'0'}}>
            <Container>
                      <h2 className="title">ลงทะเบียนผู้ป่วย</h2>

                      <Row>
                          <Col md="2">
                              <TSSelect placeholder="คำนำหน้า" options={titleOption} /*url="/api/title"*/ zIndex={3} onChange={e => setTitle(e)} value={title} require invalid={i_title} />
                          </Col>
                          <Col md="3">
                              <TSText placeholder="ชื่อ" value={firstName || ''} onChange={e => setFirstName(e.target.value)} require invalid={i_firstName} />
                          </Col>
                          <Col md="3">
                              <TSText isValidate placeholder="สกุล" value={lastName || ''} onChange={e => setLastName(e.target.value)} require invalid={i_lastName} />
                          </Col>
                          <Col md="4">
                              <TSText placeholder="เลขที่บัตรประจำตัวประชาชน" type="tel" maxLength="13" value={idCard || ''} onChange={e => setIdCard(e.target.value)} require invalid={i_idCard} />
                          </Col>
                      </Row>

                      <Row>
                          <Col md="2" lg="2">
                              <TSSelect placeholder="เพศ" fixData="gender" onChange={e => setGender(e)} value={gender} zIndex={2} require invalid={i_gender} />
                          </Col>
                          <Col md="6" lg="5">
                              <Label for="">วันเดือนปีเกิด</Label>
                              <Row /*style={{ border: (i_birthDate)?'red solid 1px':''}}*/>
                                  <Col xs="3" lg="4">
                                      <TSSelect placeholder="วัน" isDefault={true} fixData="day" onChange={e => setbDay(e)} />

                                  </Col>
                                  <Col xs="5" lg="4">
                                      <TSSelect placeholder="เดือน" isDefault={true} fixData="month" onChange={e => setbMonth(e)} />
                                  </Col>
                                  <Col xs="4" lg="4">
                                      <TSSelect placeholder="ปี" isDefault={true} fixData="year" onChange={e => setbYear(e)} />
                                  </Col>
                              </Row>
                          </Col>
                          <Col md="4" lg="5">
                              <TSText maxLength="10" type="tel" placeholder="หมายเลขโทรศัพท์" value={phone || ''} onChange={e => setPhone(e.target.value)} require invalid={i_phone} />
                          </Col>
                      </Row>

                      <Row>
                          <Col md="3">
                              <TSText placeholder="บ้านเลขที่" value={address || ''} onChange={e => setAddress(e.target.value)} require invalid={i_address} />
                          </Col>
                          <Col md="3">
                              <TSText placeholder="หมู่ที่" type="tel" value={moo || ''} onChange={e => setMoo(e.target.value)} />
                          </Col>
                          <Col md="3">
                              <TSText placeholder="ซอย" /*type="tel"*/ value={soi || ''} onChange={e => setSoi(e.target.value)} />
                          </Col>
                          <Col md="3">
                              <TSText placeholder="ถนน" /*type="tel"*/ value={road || ''} onChange={e => setRoad(e.target.value)} />
                          </Col>
                      </Row>

                      <Row>
                          <Col md="3">
                              <TSText placeholder="รหัสไปรษณีย์" type="tel" maxLength="5" value={postcode || ''} onChange={e => setPostcode(e.target.value)} require invalid={i_postcode} />
                          </Col>
                          <Col md="3">
                              <TSSelect placeholder="จังหวัด" isNew={true} url="/api/v1/province" onChange={e => setProvince(e)} value={province} require invalid={i_province} />
                          </Col>
                          <Col md="3" >
                              <TSSelect placeholder="อำเภอ" isNew={true} url="/api/v1/amphur?ProvinceID=" parent={province} onChange={e => setAmphur(e)} value={amphur} require invalid={i_amphur} />
                          </Col>
                          <Col md="3" >
                              <TSSelect placeholder="ตำบล" isNew={true} url="/api/v1/district?AmphurID=" parent={amphur} parent2={province} onChange={e => setDistrict(e)} onSelectedChange={e => setZipcode(e.districtCode)} value={district} require invalid={i_district} />
                          </Col>
                      </Row>

                      <Row>
                          <Col md="3">
                              <TSSelect placeholder="สถานภาพ" isNew={true} url="/api/v1/maritalstatus" onChange={e => setMar_Status(e)} value={mar_Status} require invalid={i_mar_Status} />
                          </Col>

                          
                          <Col md="3" style={{ display: (mar_Status!=2 ? "none":"block" )}}>
                              <TSSelect placeholder="คำนำหน้าคู่สมรส" options={titleOption} /*url="/api/title"*/ onChange={e => setMar_Title(e)} value={mar_Title} require invalid={i_mar_Title} />
                          </Col>
                          <Col md="3" style={{ display: (mar_Status != 2 ? "none" : "block") }}>
                              <TSText placeholder="ชื่อคู่สมรส" value={mar_FirstName || ''} onChange={e => setMar_FirstName(e.target.value)} require invalid={i_mar_FirstName} />
                          </Col>
                          <Col md="3" style={{ display: (mar_Status != 2 ? "none" : "block") }}>
                              <TSText placeholder="นามสกุลคู่สมรส" value={mar_LastName || ''} onChange={e => setMar_LastName(e.target.value)} require invalid={i_mar_LastName} />
                          </Col>
                       
                          <Col md="3">
                              <TSSelect placeholder="เชื้อชาติ" options={raceOption} /*url="/api/race"*/ onChange={e => setRace(e)} value={race} require invalid={i_race} />
                          </Col>
                          <Col md="3" >
                              <TSSelect placeholder="สัญชาติ" options={nationOption} /*url="/api/race"*/ onChange={e => setNation(e)} value={nation} require invalid={i_nation} />
                          </Col>
                          <Col md="3" >
                              <TSSelect placeholder="ศาสนา" isNew={true} url="/api/v1/religion" onChange={e => setReligion(e)} value={religion} require invalid={i_religion} />
                          </Col>
         
                          <Col md="4">
                              <TSSelect placeholder="อาชีพ" isNew={true} url="/api/v1/occupation" onChange={e => setOccupation(e)} value={occupation} require invalid={i_occupation} />
                          </Col>
                          <Col md="4">
                              <TSSelect placeholder="การศึกษา" isNew={true} url="/api/v1/education" onChange={e => setEducation(e)} value={education} require invalid={i_education} />
                          </Col>
                          <Col md="4" >
                              <TSText placeholder="หมู่เลือด" onChange={e => setBloodGroup(e.target.value)} value={bloodGroup || ''} require invalid={i_bloodGroup} />
                          </Col>
                      </Row>

                      <Row>
                          <Col md="2">
                              <TSSelect placeholder="คำนำหน้าบิดา" options={titleOption} /*url="/api/title"*/ onChange={e => setFather_Title(e)} value={father_Title} require invalid={i_father_Title} />
                          </Col>
                          <Col md="5">
                              <TSText placeholder="ชื่อบิดา" value={father_FirstName || ''} onChange={e => setFather_FirstName(e.target.value)} require invalid={i_father_FirstName} />
                          </Col>
                          <Col md="5" >
                              <TSText placeholder="นามสกุลบิดา" value={father_LastName || ''} onChange={e => setFather_LastName(e.target.value)} require invalid={i_father_LastName} />
                          </Col>
                      </Row>

                      <Row>
                          <Col md="2">
                              <TSSelect placeholder="คำนำหน้ามารดา" options={titleOption} /*url="/api/title"*/ onChange={e => setMother_Title(e)} value={mother_Title} require invalid={i_mother_Title}  />
                          </Col>
                          <Col md="5">
                              <TSText placeholder="ชื่อมารดา" value={mother_FirstName || ''} onChange={e => setMother_FirstName(e.target.value)} require invalid={i_mother_FirstName} />
                          </Col>
                          <Col md="5" >
                              <TSText placeholder="นามสกุลมารดา" value={mother_LastName || ''} onChange={e => setMother_LastName(e.target.value)} require invalid={i_mother_LastName} />
                          </Col>
                      </Row>

                      <Row>
                          <Col className="text-left ml-auto mr-auto" md="12">
                              <Label>ข้อมูลการแพ้ยา</Label>
                              <div className="textarea-container">
                                  <Input
                                      cols="80"
                                      placeholder="ข้อมูลการแพ้ยา"
                                      rows="4"
                                      type="textarea"
                                      value={drugNote || ''}
                                      onChange={e => setDrugNote(e.target.value)}
                                      style={{fontSize:'1em'}}
                                  ></Input>
                              </div>
                          </Col>

                          <Col className="text-left ml-auto mr-auto" md="12">
                              <Label>หมายเหตุอื่นๆ</Label>
                              <div className="textarea-container">
                                  <Input
                                      cols="80"
                                      placeholder="หมายเหตุอื่นๆ"
                                      rows="4"
                                      type="textarea"
                                      value={ptnNote || ''}
                                      onChange={e => setPtnNote(e.target.value)}
                                      style={{ fontSize: '1em' }}
                                  ></Input>
                              </div>
                          </Col>

                      </Row>

                      <Row>
                          <Col className="text-center ml-auto mr-auto" md="86">
                              <div className="send-button">

             
                                  <Button
                                              block
                                              className="btn-round"
                                              color="info"
                                              href="#pablo"
                                              onClick={handleSubmit}
                                              size="lg"
                                          >
                                              บันทึกข้อมูล
                                  </Button> 
                        

                                  {/* Confirm */}
                                  <Modal
                                      modalClassName="modal-mini modal-info"
                                      toggle={() => setModalConfirm(false)}
                                      isOpen={modalConfirm}
                                  >
                                      <div className="modal-header justify-content-center">
                                          <div className="modal-profile">
                                              <i className={icon} style={{ color: 'blue', fontSize: '2em' }}></i>
                                          </div>
                                      </div>
                                      <ModalBody>

                                          <p>{(icon != "fa fa-spinner fa-w-16 fa-spin fa-lg") ? "ยืนยันการบันทึกข้อมูล" : "กำลังตรวจสอบข้อมูล"}</p>
                                          <p>  </p>
                                      </ModalBody>
                                      <div className="modal-footer">
                                          <Button
                                              className="btn-neutral"
                                              color="link"
                                              type="button"
                                              onClick={() => setModalConfirm(false)}
                                          >
                                              ยกเลิก
                                      </Button>

                                          <Button
                                              className="btn-neutral"
                                              color="link"
                                              type="button"
                                              onClick={handleConfirm}
                                              disabled={icon == "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                          >
                                              ยืนยัน
                                      </Button>
                                      </div>
                                  </Modal>

                                  {/* Finish */}
                                  <Modal
                                      modalClassName="modal-mini modal-success"
                                      toggle={() => {
                                          const { from } = props.location.state || { from: { pathname: "/hospital/patient" } };
                                          props.history.push(from);
                                      }}
                                      isOpen={modalNote}
                                  >
                                      <div className="modal-header justify-content-center">
                                          <div className="modal-profile">
                                              <i className={"far fa-calendar-check"} style={{ color: 'green', fontSize: '2em' }}></i>
                                          </div>
                                      </div>
                                      <ModalBody>
                                          <p>บันทึกข้อมูลสำเร็จ</p>
                                          <p>  </p>
                                      </ModalBody>
                                      <div className="modal-footer" style={{ justifyContent: 'center' }}>
                                          <Button
                                              className="btn-neutral"
                                              color="white"
                                              type="button"
                                              onClick={() => {
                                                  const { from } = props.location.state || { from: { pathname: "/hospital/patient" } };
                                                  props.history.push(from);
                                              }
                                              }
                                          >
                                              ตกลง
                                      </Button>
                                      </div>
                                  </Modal>

                                  {/* Error */}
                                  <Modal
                                      modalClassName="modal-mini modal-danger"
                                      toggle={() => setModalError(false)}
                                      isOpen={modalError}
                                  >
                                      <div className="modal-header justify-content-center">
                                          <div className="modal-profile">
                                              <i className="fa fa-times" style={{ color: 'red', fontSize: '2em' }}></i>
                                          </div>
                                      </div>
                                      <ModalBody>
                                          <p>ไม่สามารถบันทึกข้อมูลได้</p>
                                          <p> {errMsg} </p>
                                      </ModalBody>
                                      <div className="modal-footer justify-content-center">
                                          <Button
                                              className="btn-neutral"
                                              color="neutral"
                                              type="button"
                                              onClick={() => setModalError(false)}
                                          >
                                              ตกลง
                                      </Button>
                                      </div>
                                  </Modal>
                              </div>
                          </Col>
                      </Row>

                  </Container>
        </div>
        <DefaultFooter />
      </div>
    </>
  );
}

export default ChildRegister;
